import { delay } from "@/hooks/useReveal";

const WEEKS = [
  ["Week 0", "AI check", "30 minutes. Bring the list of tools you use. Leave knowing what is fine, what needs fixing, and what it would cost."],
  ["Week 1", "Licence signed", "Mandate and documentation ready. Your team knows who to ask."],
  ["Weeks 2–4", "Readiness", "Inventory, classification, policy and the first AI literacy session. Tools set up where they belong."],
  ["Ongoing", "Your officer", "Check-ins, feature reviews and regulatory watch, from one team that signs, answers and stays."],
];

export const FirstThirtyDays = () => (
  <section className="section section--navy surface-dark" aria-labelledby="proc-title" data-testid="first-30-days-section">
    <div className="container">
      <div className="stack section-head" data-reveal>
        <p className="eyebrow">The first 30 days</p>
        <h2 id="proc-title" className="title">From first call to a named AI officer in a month.</h2>
      </div>
      <ol className="timeline">
        {WEEKS.map(([when, title, text], i) => {
          const last = i === WEEKS.length - 1;
          return (
            <li key={when} data-reveal style={delay(i, 100)}>
              <div className="timeline__track" aria-hidden="true">
                <span className={`timeline__dot${last ? " timeline__dot--open" : ""}`} />
                <span className={`timeline__line${last ? " timeline__line--dashed" : ""}`} />
              </div>
              <span className="timeline__when">{when}</span>
              <h3 className="timeline__title">{title}</h3>
              <p className="timeline__text">{text}</p>
            </li>
          );
        })}
      </ol>
    </div>
  </section>
);
